import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';

export class PositionDiffersDialogComponent {
    public modalInstanceService: ng.ui.bootstrap.IModalInstanceService = this as any;
    public resolve: {
      contentTranslateKey: string
    };

    public edit() {
        this.modalInstanceService.close({ $value: true });
    }

    public everythingCorrect() {
        this.modalInstanceService.close({ $value: false });
    }
}

angular.module('app.common').component('positionDiffersDialogComponent', {
    template: require('./position-differs-dialog.component.html'),
    controller: PositionDiffersDialogComponent,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/components/google-map/position-differs-dialog/position-differs-dialog.component.ts